import type { Bucket } from '../api/types.js';

export interface RankedDay {
  yyyymmdd: string;
  intervalGallons: number;
}

export const TOP_N = 5;

export function bucketDateInTz(startIso: string, timezone: string): string {
  // en-CA's locale renders YYYY-MM-DD; combined with timeZone, this gives the
  // local-date string in the desired timezone without a library.
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(startIso));
}

export function pickTopDays(buckets: Bucket[], timezone: string, n: number = TOP_N): RankedDay[] {
  return buckets
    .filter((b) => b.intervalGallons > 0)
    .map((b) => ({
      yyyymmdd: bucketDateInTz(b.startIso, timezone),
      intervalGallons: b.intervalGallons,
    }))
    .sort((a, b) => {
      if (b.intervalGallons !== a.intervalGallons) {
        return b.intervalGallons - a.intervalGallons;
      }
      // Tie break: more recent date wins.
      return a.yyyymmdd < b.yyyymmdd ? 1 : -1;
    })
    .slice(0, n);
}
